export default {
  border: {
    radius: '8px',
    thickness: '2px',
    style: 'solid',
  },
  padding: {
    horizontal: '0.9375rem',
    vertical: '0.6875rem',
  },
};
